export enum DlImageUploadStatus {
  UPLOAD_ERROR = 'upload_error', // Upload error
  UPLOADED = 'uploaded', // Image has been uploaded
  AWAITING_UPLOAD = 'awaiting_upload', // Waiting for upload to begin
}
